import { BrandMark, Select, SelectItem } from '@reelplicate/ui';

import {
  HANDLE_PLATFORM_LABEL,
  HANDLE_PLATFORMS,
  type HandlePlatform,
  type PersonaPlatform,
} from './platforms';

const TikTokMark = ({ className }: { className?: string }) => (
  <BrandMark name="tiktok" size={16} className={className} />
);
const InstagramMark = ({ className }: { className?: string }) => (
  <BrandMark name="instagram" size={16} className={className} />
);
const YouTubeMark = ({ className }: { className?: string }) => (
  <BrandMark name="youtube" size={16} className={className} />
);
const FacebookMark = ({ className }: { className?: string }) => (
  <BrandMark name="facebook" size={16} className={className} />
);
const MARKS = {
  TIKTOK: TikTokMark,
  INSTAGRAM: InstagramMark,
  YOUTUBE: YouTubeMark,
  FACEBOOK: FacebookMark,
} as const;

/**
 * A platform picker with the platform's own mark (Figma: Select with a 16px
 * mark). TikTok or Instagram unless `platforms` says otherwise.
 */
export function PlatformSelect<P extends PersonaPlatform = HandlePlatform>({
  value,
  onValueChange,
  platforms = HANDLE_PLATFORMS as readonly PersonaPlatform[] as readonly P[],
  size = 'md',
  label,
  className = 'w-36 shrink-0',
}: {
  value: P;
  onValueChange: (platform: P) => void;
  platforms?: readonly P[];
  size?: 'sm' | 'md';
  /** Accessible name, e.g. "Competitor 1 account 2 platform". */
  label: string;
  className?: string;
}) {
  return (
    <Select
      size={size}
      className={className}
      value={value}
      onValueChange={(next) => onValueChange(next as P)}
      leadingIcon={MARKS[value]}
      aria-label={label}
    >
      {platforms.map((platform) => (
        <SelectItem key={platform} value={platform}>
          {HANDLE_PLATFORM_LABEL[platform]}
        </SelectItem>
      ))}
    </Select>
  );
}
